// See legal_text_selectors.py for more information
import {assertAndContinue} from 'Asserts';
import {MinimalSchemaTag, SchemaTag, UnaffiliatedSchemaTag} from 'folder-items/FileConstants';
import {FIELD_TYPES, SchemaField} from 'schemas/fields/SchemaFieldConstants';

/**
 * Function that asserts the field does not have a legalTextSelector.
 *
 * Consolidating into a function should allow for easier searching later ("what doesn't yet support this?")
 */
export function assertAndContinueNoLegalTextSelector(schemaField: SchemaField): void {
  assertAndContinue(!schemaField.legalTextSelectorId, 'Did not expect field to have a legalTextSelectorId');
}

export function fieldTypeSupportsLegalText(fieldType: string): boolean {
  return fieldType === FIELD_TYPES.FLOAT.type;
}

export function schemaTagHasLegalText(tag: SchemaTag | UnaffiliatedSchemaTag | MinimalSchemaTag): boolean {
  return fieldTypeSupportsLegalText(tag.tagSchemaField.fieldType) && tag.schemaFieldSelectorOptionIds != null;
}
